import { useSelector } from "react-redux";

import { getFormattedLocation } from "redux/selectors/location";

import GoogleAd from "components/GoogleAd";

export const FeaturedProducts = ({
  categoryName,
  className,
  titleOverride,
}: {
  categoryName?: string;
  className?: string;
  titleOverride?: string;
}) => {
  const leaflyLocation = useSelector(getFormattedLocation);

  const title =
    titleOverride?.replace("{{LOCATION}}", leaflyLocation) ||
    `Featured ${categoryName || "Cannabis Products"} in ${leaflyLocation}`;

  return (
    <section className={className}>
      <h2 className="mb-sm">{title}</h2>
      <div className="row">
        <div className="col-3 lg:col-3" data-testid="featured-product-0">
          <div className="elevation-low rounded overflow-hidden">
            <GoogleAd
              adPath="/13212770/product/product_slot_1"
              style={{ minHeight: 266 }}
              sizes={{ desktop: ["fluid"], mobile: ["fluid"] }}
            />
          </div>
        </div>
        <div className="col-3 lg:col-3" data-testid="featured-product-1">
          <div className="elevation-low rounded overflow-hidden">
            <GoogleAd
              adPath="/13212770/product/product_slot_2"
              style={{ minHeight: 266 }}
              sizes={{ desktop: ["fluid"], mobile: ["fluid"] }}
            />
          </div>
        </div>
        <div
          className="col-3 mt-md lg:col-3 lg:mt-none"
          data-testid="featured-product-2"
        >
          <div className="elevation-low rounded overflow-hidden">
            <GoogleAd
              adPath="/13212770/product/product_slot_3"
              style={{ minHeight: 266 }}
              sizes={{ desktop: ["fluid"], mobile: ["fluid"] }}
            />
          </div>
        </div>
        <div
          className="col-3 mt-md lg:col-3 lg:mt-none"
          data-testid="featured-product-3"
        >
          <div className="elevation-low rounded overflow-hidden">
            <GoogleAd
              adPath="/13212770/product/product_slot_4"
              style={{ minHeight: 266 }}
              sizes={{ desktop: ["fluid"], mobile: ["fluid"] }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
